<template>
    <div id="saas">
        <meta name="robots" content='noindex,nofollow'/>
        <div id="sections-area">
            <div class="">
                <div id="Embed">
                    <section class="how-it-works-section mb-5">
                        <div v-if="!paymentDone" class="container text-center">
                            <div class="row justify-content-center">
                                <div class="col">
                                    <h1 class="section-title m-5">Hey {{ name }}, Start Your Subscription Now 🌀</h1>
                                </div>
                            </div>
                            <div class="my-5">
                                <div id="paypal-button-container"></div>
                            </div>
                            <div class="text-center my-4">
                                By starting your subscription, you agree to our
                                <a target="_blank" href="/docs/terms-of-use.pdf">Terms & Conditions</a>
                                and
                                <a target="_blank" href="/docs/privacy-policy.pdf">Privacy Policy</a>
                            </div>
                        </div>
                        <div v-else class="container text-center">
                            <div class="row justify-content-center">
                                <div class="col">
                                    <h1 class="section-title m-5">You did it!🌀🥳</h1>
                                    <span>Your app is now going to production-mode.</span><br>
                                    <span>You'll get an email with a link to your app, and then your 7-days start. (it may take up to 3 business days)🤩</span>
                                </div>
                            </div>
                            <div class="my-5">
                                <iframe width="560" height="315" src="https://www.youtube.com/embed/ZbZSe6N_BXs?start=28&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <pricing commission="true" v-if="!paymentDone"></pricing>

        </div>
       <contact></contact>
        <img class="background-fixed-img" src="/img/startup-bg.jpg" alt="SPIRITT background">
    </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import Navbar from './components/Navbar.vue';
  import Hero from './components/Hero.vue';
  import FloatingImages from './components/FloatingImages.vue';
  import About from './components/About.vue';
  import WhyUs from "./components/WhyUs.vue";
  import Partners from './components/Partners.vue';
  import Contact from './components/Contact.vue';
  import StartNow from "./components/StartNow.vue";
  import HowItWorks from "./components/HowItWorks.vue";
  import Pricing from "./components/Pricing.vue";
  import Comparison from "./components/Comparison.vue";
  import WhyChooseUs from './components/WhyChooseUs.vue';

  export default {
    name: 'payment',
    props: ['name', 'plan'],
    computed: {
      ...mapState('layout', {
        language: state => state.language,
      }),
      ...mapGetters({
        mobile: 'layout/mobile',
        modal: 'layout/modal',
        isScrolled: 'layout/isScrolled',
        isMvpModalOpen: 'layout/isMvpModalOpen',
      }),
    },
    data() {
      return {
        paymentDone: false,
      }
    },
    components: {
      StartNow,
      'navbar': Navbar,
      'hero': Hero,
      'floating-images': FloatingImages,
      'about': About,
      'start-now': StartNow,
      'why-us': WhyUs,
      'partners': Partners,
      'contact': Contact,
      'how-it-works': HowItWorks,
      'pricing': Pricing,
      'comparison': Comparison,
      'why-choose-us': WhyChooseUs
    },
    methods: {
      ...mapActions({
        updateModalTitle: 'layout/updateModalTitle',
        updateModalVisibility: 'layout/updateModalVisibility',
        updateModalContent: 'layout/updateModalContent',
        updateIsScrolled: 'layout/updateIsScrolled',
        updateMvpModalVisibility: 'layout/updateMvpModalVisibility',
      }),
      paymentHasDone() {
        this.paymentDone = true;
      },
      makeSubscription(data, actions) {
        return actions.subscription.create({
          'plan_id': this.plan
        })
      },
      handleScroll () {
        return this.isScrolled && window.scrollY ? null : this.updateIsScrolled({
          payload: {
            scrolled: window.scrollY,
          },
        });
      },
    },
    mounted () {

      window.addEventListener('scroll', this.handleScroll);
        paypal.Buttons({
          locale: 'en_US',
          style: {
            shape: 'pill',
            color: 'blue',
            layout: 'vertical',
            label: 'subscribe'
          },
          createSubscription: (data, actions) => this.makeSubscription(data, actions),
          onApprove: this.paymentHasDone
        }).render('#paypal-button-container');

    },
  }
</script>
<style lang="css" scoped>
    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans:300,400,700&display=swap');
    #saas {
        font-family: Josefin Sans, sans-serif;
        font-size: 1.125rem;
        position: relative;
        overflow: hidden;
        scroll-behavior: smooth;
        display: block;
    }
    #Embed{
        background-color: #f1f1f1;
        padding-bottom: 30px;
    }
    .background-fixed-img{
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 1;
        position: fixed;
        right: 0;
        top: 0;
        bottom: 0;
        transition: opacity 1s;
        background-attachment: fixed;
        object-fit: cover;
        z-index: -1;
    }
    .section-title {
        font-size: 45px;
        font-weight: 300;
        line-height: 1;
    }
    @media (max-width: 767px) and (min-width: 320px){
        .background-fixed-img {
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            opacity: 1;
            position: fixed;
            right: 0;
            top: 0;
            bottom: 0;
            transition: opacity 1s;
            z-index: -1;
        }
    }
    .saas-contact-us {
        background-image: linear-gradient(to right top, rgba(65, 126, 170, 0.95), rgba(51, 122, 187, 0.95), rgba(60, 115, 202, 0.95), rgba(88, 104, 211, 0.95), rgba(124, 88, 213, 0.95), rgba(136, 76, 209, 0.95), rgba(149, 61, 203, 0.95), rgba(161, 40, 196, 0.95), rgba(151, 36, 192, 0.95), rgba(140, 32, 188, 0.95), rgba(130, 29, 184, 0.95), rgba(119, 25, 180, 0.95));
        background-attachment: fixed;
        background-size: cover;
        padding-top: 200px;
        padding-bottom: 80px;
        color:#fff;
        position: relative;
        overflow: hidden;
        min-height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

    }
    .saas-contact-us:before {
        content: "";
        position: absolute;
        top: -100px;
        right: -50px;
        height: 200px;
        width: 130%;
        -webkit-transform: rotate(-4deg);
        -ms-transform: rotate(-4deg);
        transform: rotate(-4deg);
        z-index: 10;
        background: #f1f1f1;
    }
    .social-btn{
        text-align: center;
        display: inline-block;
        width: 35px;
        height: 35px;
        margin-left: 10px;
        border-radius: 50%;
        border: solid 1px #fff;
        color: #fff;
        padding-top: 3px;
    }
    .social-btn:hover {
        background-color: #fff;
        color: #751da7;
    }
    .contact-title{
        margin-bottom: 35px;
        font-size: 45px;
    }
    .contact-p{
        font-size:  20px;
        margin-bottom: 60px;
    }
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #fff;
        opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #fff;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #fff;
    }
    .form-control {
        font-size: 18px;
        padding: 15px 15px;
        border-radius: 25px 25px 25px 25px;
        border: 1px solid #CBCBCB;
        background-color: transparent;
        color: #ffffff;
        direction: ltr;
        text-align: left;
    }
    button.secondary {
        height: 48px;
        min-width: 185px;
        color: #ffffff;
        font-weight: 500;
        border-radius: 22px 25px 22px 22px;
        cursor: pointer;
        background: linear-gradient(144deg, #00a5b7 10%, #00c092 65%);
        margin-top: 15px;
    }
    button.secondary:hover {
        color: #751da7;
    }
</style>
